import { getDefaultHeaders } from "./utils";

export async function stageWiseStats() {
  let headers = await getDefaultHeaders();
  const requestOptions = {
    method: "GET",
    headers: headers,
  };
  const url = "/api/stage-wise-stats/";
  try {
    const response = await fetch(url, requestOptions);
    const jsonResponse = await response.json();
    return jsonResponse;
  } catch (err) {
    console.log("ERROR 16", err);
    return [];
  }
}
